// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Branding-modulewrapper8kZ"};